import Swiper from '@src/components/swiper';

export const moreThanThreeCardsSwiper = new Swiper('.swiper-article-list-more-than-three-cards', {
  grabCursor: true,
  pagination: {
    el: '.swiper-pagination-article-list',
    clickable: true
  },
  slidesPerView: 'auto',
  centeredSlides: false,
  breakpoints: {
    // On desktop and bigger.
    768: {
      spaceBetween: 24,
    },
    // On mobile (>= 1px).
    1: {
      spaceBetween: 48,
    }
  }
});
